import styled from "styled-components"

import ArticleCard from "components/card/article"

export const StyledCard = styled(ArticleCard)`
  margin: 0;
`
